import { border } from "@mui/system";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Table, Button, Dropdown, Card, Form, Badge } from "react-bootstrap";
import { Link, useHistory, useParams } from "react-router-dom";
import "./AuctionOrderView.css";
import moment from "moment";
import swal from "sweetalert";
import { useContext } from "react";
import { serverInfo } from "../../../../../../App";

const AuctionOrderView = () => {
  const { imageCdnUrl } = useContext(serverInfo);
  const { id } = useParams();

  const [orderView, setOrderListView] = useState("");
  const [orderViewStatus, setOrderListViewStatus] = useState("");

  const getAuctionData = () => {
    axios
      .get(`/api/admin/auction/order/${id}`)
      .then((res) => {
        if (res.data.status === 200) {
          setOrderListView(res.data.auction);
          setOrderListViewStatus(res?.data?.ordered_bid?.status);
        }
      });
  };

  useEffect(() => {
    getAuctionData();
  }, []);

  const handleDeliveryStatus = (data) => {
    axios
      .post(
        `/api/admin/auction/order/status/${data}/${orderView.id}`
      )
      .then((res) => {
        if (res.data.status === 200) {
          swal("Order status updated", res.data.message, "success");
          getAuctionData();
        }
      });
  };

  return (
    <div className="container">
      <Card className="cardMain">
        <Link to="/superstar-admin/auction/product-list/sold">
          <h4>
            <Badge bg="danger">
              <i className="fa-solid fa-chevron-left"> </i> Back
            </Badge>
          </h4>
        </Link>
        <Card.Header className="CardHeader">Order Details</Card.Header>
        <Card.Body>
          <div className="row" style={{ padding: "10px" }}>
            <div className="col-md-4">
              <h5>
                Payment Status :{" "}
                {orderView?.ordered_bid?.payment_status == 1 ? (
                  <Badge bg="success">Paid</Badge>
                ) : (
                  <Badge bg="danger">Unpaid</Badge>
                )}
              </h5>
              <h5>
                Delivery Charge Payment Status :{" "}
                {orderView?.ordered_bid?.delivery_charge_payment_status == 1 ? (
                  <Badge bg="success">Paid</Badge>
                ) : (
                  <Badge bg="danger">Unpaid</Badge>
                )}
              </h5>
              
            </div>
            <div className="col-md-4"></div>
            <div className="col-md-4">
              <h5>Delivery Status</h5>
              {/* value = {orderView.status} */}
              <Form.Select
                aria-label="Default select example"
                onChange={(e) => handleDeliveryStatus(e.target.value)}
                value={orderView?.ordered_bid?.status}
              >
                {/* {orderView?.status < 1 ? (
                  <option value="1">Ordered</option>
                ) : (
                  <option>Ordered</option>
                )}

                {orderView?.status >= 1 ? (
                  <option value="2">Received</option>
                ) : (
                  <option>Received</option>
                )}

                {orderView?.status == 2 ? (
                  <option value="3">Out for Delivery</option>
                ) : (
                  <option>Out for Delivery</option>
                )}

                {orderView?.status == 3 ? (
                  <option value="4">Delivered</option>
                ) : (
                  <option>Delivered</option>
                )} */}

                <option>--Select Status--</option>
                <option value="0">Pending</option>
                <option value="1">Ordered</option>
                <option value="2">Received</option>
                <option value="3">Out for Delivery</option>
                <option value="4">Delivered</option>
              </Form.Select>
            </div>
          </div>
          <hr />
          <div className="row" style={{ padding: "10px" }}>
            <div className="col-md-4">
              <img
                src={imageCdnUrl + orderView.star?.image}
                alt=""
                className="img-fluid"
                style={{
                  height: "150px",
                  width: "170px",
                  border: "3px solid #fcc106",
                  borderRadius: "50%",
                }}
              />
            </div>
            <div className="col-md-4">
              <h4 style={{ paddingLeft: "8px" }}>Star Info</h4>
              <p style={{ paddingLeft: "8px" }}>
                <b>Name : </b>
                {orderView.star?.first_name} {orderView.star?.last_name}
              </p>
              <p style={{ paddingLeft: "8px" }}>
                <b>Phone No : </b>
                {orderView.star?.phone}
              </p>
              <p style={{ paddingLeft: "8px" }}>
                <b>Email : </b>
                {orderView.star?.email}
              </p>
            </div>
            <div className="col-md-4">
              {/* <h5>Delivery Status</h5> */}
              {/* value = {orderView.status} */}
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-md-4">
              <h4 style={{ paddingLeft: "8px" }}>User Info</h4>
              <p style={{ paddingLeft: "8px" }}>
                <b>Name : </b>
                {orderView?.ordered_bid?.user?.first_name} {orderView?.ordered_bid?.user?.last_name}
              </p>
              <p style={{ paddingLeft: "8px" }}>
                <b>Phone No : </b>
                {orderView?.ordered_bid?.user?.phone}
              </p>
              <p style={{ paddingLeft: "8px" }}>
                <b>Email : </b>
                {orderView?.ordered_bid?.user?.email}
              </p>
              <p style={{ paddingLeft: "8px" }}>
                <b>Address : </b>
                {orderView?.ordered_bid?.area}, {orderView?.ordered_bid?.city?.name}, <br />{" "}
                {orderView?.ordered_bid?.state?.name}, {orderView?.ordered_bid?.country?.name}
              </p>
              <p style={{ paddingLeft: "8px" }}>
                <b>Delivery Date : </b>
                {moment(orderView?.delivery_date).format("LL")}
              </p>
            </div>
            <div className="col-md-4"></div>
            <div className="col-md-4">
              <h4>
                <b>Order : </b>#{orderView?.ordered_bid?.order_no}
              </h4>
              <p>
                <b>Order Status : </b>
                <Badge bg="secondary">
                  {orderView?.ordered_bid?.status == 0
                    ? "Pending" : orderView?.ordered_bid?.status == 1
                    ? "Ordered"
                    : orderView?.ordered_bid?.status == 2
                    ? "Received"
                    : orderView?.ordered_bid?.status == 3
                    ? "Out for Delivery"
                    : "Delivered"}
                </Badge>
              </p>
              <p>
                <b>Order Date : </b>
                {moment(orderView?.ordered_bid?.created_at).format("LL")}{" "}
                {moment(orderView?.ordered_bid?.created_at).format("LT")}
              </p>
              <p>
                <b>Base price : </b>
                {orderView?.base_price}
              </p>
              <p>
                <b>User Bid : </b>
                {orderView?.ordered_bid?.amount}
              </p>
              <p>
                <b>Delivery Country : </b>
                {orderView?.ordered_bid?.delivery_charge?.country}
              </p>
              <p>
                <b>Delivery Company : </b>
                {orderView?.ordered_bid?.delivery_charge?.courier_company}
              </p>
            </div>
          </div>

          <hr />
          <div className="row" style={{ overflowX: "auto" }}>
            <Table
              className="table w-100"
              striped
              bordered
              hover
              variant="warning"
            >
              <thead className="table-info">
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Product Name</th>
                  <th scope="col">Image</th>
                  <th scope="col">Quantity</th>
                  <th scope="col">Unit Price</th>
                  <th scope="col">Total Price</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">1</th>
                  <td>{orderView?.title}</td>
                  <td>
                    <img
                      src={imageCdnUrl + orderView?.image}
                      alt=""
                      className="img-fluid"
                      style={{
                        height: "50px",
                        border: "3px solid #fcc106",
                        borderRadius: "10px",
                      }}
                    />
                  </td>
                  <td>1</td>
                  <td>{orderView?.ordered_bid?.amount}</td>
                  <td>{1 * orderView?.ordered_bid?.amount}</td>
                </tr>
              </tbody>
            </Table>
          </div>

          <br />
          <div className="row">
            <div className="col-md-9"></div>
            <div className="col-md-3">
              <p>Sub Total : ${orderView?.ordered_bid?.amount}</p>
              {/* <p>Tax : {orderView?.tax}</p> */}
              <p>Delivery Charge : ${orderView?.ordered_bid?.delivery_charge?.courier_charge}</p>
              <hr />
              <p>Grand Total : ${orderView?.ordered_bid?.total_price}</p>
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default AuctionOrderView;
